import React, { useState } from 'react';

export const modalContext = React.createContext<{
  isVisible: boolean;
  setIsVisible: (newValue) => void;
}>({
  isVisible: false,
  setIsVisible: () => undefined,
});

export default function ModalProvider({ children }) {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <modalContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </modalContext.Provider>
  );
}
